import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { User, Package, Heart, MapPin, Hammer, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/account", label: "Profile", icon: User, end: true },
  { to: "/account/orders", label: "Orders", icon: Package },
  { to: "/wishlist", label: "Wishlist", icon: Heart },
  { to: "/account/addresses", label: "Addresses", icon: MapPin },
  { to: "/account/customizations", label: "Custom Requests", icon: Hammer },
];

export default function AccountLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && !user?.user_id) navigate("/login"); }, [user, loading, navigate]);
  if (loading || !user?.user_id) return <div className="py-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="mx-auto max-w-[1200px] px-4 md:px-8 py-10">
      <div className="grid lg:grid-cols-4 gap-8">
        <aside className="h-fit rounded-3xl border border-border p-5">
          <div className="flex items-center gap-3 border-b border-border pb-4">
            {user.picture ? <img src={user.picture} alt="" className="h-11 w-11 rounded-full object-cover" /> : <div className="grid h-11 w-11 place-items-center rounded-full bg-midnight text-white font-bold">{user.name?.[0]?.toUpperCase()}</div>}
            <div><p className="font-bold text-midnight line-clamp-1">{user.name}</p><p className="text-xs text-muted-foreground line-clamp-1">{user.email}</p></div>
          </div>
          <nav className="mt-3 space-y-1">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} data-testid={`account-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold ${isActive ? "bg-midnight text-white" : "text-muted-foreground hover:bg-secondary"}`}>
                <l.icon className="h-4 w-4" /> {l.label}
              </NavLink>
            ))}
            {user.role === "admin" && <Link to="/admin" className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold text-gold-dark hover:bg-secondary">Admin Panel</Link>}
            <button onClick={logout} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold text-red-600 hover:bg-secondary"><LogOut className="h-4 w-4" /> Logout</button>
          </nav>
        </aside>
        <div className="lg:col-span-3"><Outlet /></div>
      </div>
    </div>
  );
}
